<template>
  <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      核销信息
    </van-notice-bar>
    <van-cell-group>
      <van-cell title="商户名称" :value="detail.store_name||'暂无信息'" />
      <van-cell title="消费者姓名" :value="detail.name||'暂无信息'" />
      <van-cell title="消费者手机号" :value="detail.tel||'暂无信息'" />
      <van-cell title="卡券名称" :value="detail.title||'暂无信息'" />
      <van-cell title="领券时间" :value="detail.receive_time||'暂无信息'" />
      <van-cell title="使用状态" :value="detail.use_status==1?'已核销':'未使用'" />
      <van-cell v-if="detail.use_status==1" title="使用时间" :value="detail.use_time||'暂无信息'" />
      <van-cell title="卡券编号" :value="detail.card_num||'暂无信息'" />
      <van-cell title="卡券类型" :value="detail.card_type||'暂无信息'" />
      <van-cell title="卡券颜色" :value="detail.color||'暂无信息'" />
      <van-cell title="消费者满多少" :value="detail.consumer_full_money||'暂无信息'"/>
      <van-cell title="消费者减多少" :value="detail.consumer_reduce_money||'暂无信息'"/>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.detail = this.$route.query;
      console.log(this.detail);
    },
  },
};
</script>
<style lang="less" scoped>
</style>